import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Notification, NotificationLevel } from '@steelbuy/ui-primitive';
import { RoutePath } from '../../router/Routes';
import { TableLayout } from '../../views/layouts/table-layout/TableLayout';
import { PageHeader } from '../page-header/PageHeader';

export const CreateListingDraftNotFound = () => {
    const { t } = useTranslation('translation');
    const navigate = useNavigate();

    return (
        <>
            <PageHeader
                pageTitle={t('application.createListingDraftNotFound.pageTitle')}
                previousPageTitle={t('application.createListingDraftNotFound.previousPageTitle')}
                onBackClick={() => navigate(RoutePath.CREATE_LISTING_WIZARD)}
            />
            <TableLayout>
                <Notification
                    level={NotificationLevel.WARNING}
                    message={t('application.createListingDraftNotFound.notificationMessage')}
                    labelActionButton={t('application.createListingDraftNotFound.notificationButtonLabel')}
                    onClickActionButton={() => navigate(RoutePath.CREATE_LISTING_WIZARD)}
                />
            </TableLayout>
        </>
    );
};
